import Event from '../../core/Event';

export default class OrderDeliveryFeeReceived extends Event {
    public static type = 'OrderDeliveryFeeReceived';

    constructor(public readonly deliveryFee: number) {
        super(OrderDeliveryFeeReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDeliveryFeeReceived.ts